import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Modal } from '@fluentui/react/lib/Modal';
import { MobilityComposeForm } from 'owa-mobility-compose';

/**
 * Component for rendering the mobility compose form.
 */
export default observer(function MobilityComposeRenderer() {
    const [isOpen, setOpen] = React.useState(true);
    const closeCompose = React.useCallback(() => {
        setOpen(false);
    }, []);

    return (
        <Modal isOpen={isOpen} isBlocking={false}>
            <MobilityComposeForm onDismiss={closeCompose} entrySource="QuickCompose_Peek" />
        </Modal>
    );
});
